import React,{useEffect,useState,useRef} from 'react';
import axios from 'axios';
import ReactToPrint from 'react-to-print';
import {ComponentToPrint} from './Print';
import { GoogleMap, useLoadScript,Marker,InfoWindow,Polyline} from '@react-google-maps/api';
import '../pipeline.css'
const mapContainerStyle={
  width:"100%",
  height:`80vh`,
};
const estilo={
  disableDefaultUI:true,
  zoomControl:true
}
const center={
  lat:-25.948160546759134, 
  lng:32.58577582313654
};

const options = {
  strokeColor: '#FF0000',
  strokeOpacity: 0.8,
  strokeWeight: 2,
  fillColor: '#FF0000',
  fillOpacity: 0.35,
  clickable: false,
  draggable: false,
  editable: false,
  visible: true,
  radius: 30000,
  paths: [
    {lat: 37.772, lng: -122.214},
    {lat: 21.291, lng: -157.821},
    {lat: -18.142, lng: 178.431},
    {lat: -27.467, lng: 153.027}
  ],
  zIndex: 1
};
const path = [];
function PipeLine() {
  const [manutencao,setManutencao]=useState(null);
  const [selecionado,setSelecionado]=useState(null);
  const [ls,setLs]=useState(null);
  const TabelaDemanu=useRef();
  const [sd,setSd]=useState(null);
  const [dados,setDados]=useState(new Date());
  const [dado,setDado]=useState(new Date());
  const [post,setPost]=useState('');
  const casa=()=>{
    console.log(sd)
    axios({
      method:"post",
      url:`${localStorage.getItem('url')}/web/ManutencaoPrv/`,
      headers:{'Authorization':`token ${localStorage.getItem('token')}`,'Content-Type':'application/json' },
      data:{posto:sd}
  }).then(dat=>{ if(dat.status!==200){
      throw Error('Dados de acesso invalidos');  
          }
      return dat
   } ).then( df=>{
     console.log(df.data)
      setLs(df.data);
     
    }
  
     ).catch(e=>{
      setError(e.message );
  })
  
  }
  const Hcasa=e=>{
    e.preventDefault();
    casa();
  }
  useEffect(()=>{
    axios({
        method:"post",
        url:`${localStorage.getItem('url')}/web/prv/`,
        headers:{'Authorization':`token ${localStorage.getItem('token')}`,'Content-Type':'application/json' },
        data:{id:"sds"}
    }).then(dat=>{ if(dat.status!==200){
        throw Error('Dados de acesso invalidos');  
            }
        return dat
     } ).then( df=>{
      setClientes(df.data);
      console.log(Cliente);
       
      }
   
       ).catch(e=>{
        setError(e.message );
    })

},[]);
  const Send=()=>{

  }
  const SearchD=(row)=>{
       
    return row.filter((row)=>
    
    row.nome.toLowerCase().indexOf(post)>-1)
}
const SearchMeter=(row)=>{
    let idado=new Date(dado)
    let fdados=new Date (dados)
    idado=idado.getTime()
    fdados=fdados.getTime()
    console.log(idado)
    console.log(fdados)
    return row.filter((row)=>
    idado<=(new Date(row.data_de_m)).getTime() && (new Date(row.data_de_m)).getTime() <=fdados);
}


  let [Cliente,setClientes]=React.useState(null);
  const [error,setError]=useState();
  const {isLoaded,loadError}=useLoadScript({
    googleMapsApiKey:"AIzaSyDPULpH4t1OW6WExQUqmD3K1EuOCBKq6Ec",
  }); 
  if(loadError) return "errro lendo"
  if(!isLoaded) return "Loading Map"
  
return (<div className='popa'>
  
    <GoogleMap mapContainerStyle={mapContainerStyle} zoom={8}
    center={center} options={estilo}>
    {Cliente && Cliente.map((marker)=>(
             <Marker position={{  lat:parseFloat(marker.lat), 
              lng:parseFloat(marker.lon)}}
              icon={{url:'/gas-tank.png'}}
              onClick={()=>{
                setSelecionado(marker);
                casa();
      
              }}/>
              
    ))}
    { manutencao && <div className='HistoricoM'>



    </div>

    }
    {ls && <div className='manutencao_total'>
      
    <table >
            <thead>
            <tr>
            <th>Consumo </th>
            <th>pressao </th>
            <th>Tempertura</th>
            <th>Escavacoes</th>
            <th>Integridade</th>
            <th>data</th>
            <th>idPosto</th>
            <th>idTecnico</th>
            <th>Posto</th>
            <th>Lat</th>
            <th>Lon</th>
            <th>Imagem</th>
            </tr>
            </thead>
    
     
         {ls && <tbody>{SearchMeter(SearchD(ls)).map((val,key)=>
            {
            return  <tr> 
            <td>{val.consumo_gas}</td>
            <td>{val.pressao_gas}</td>
            <td>{val.escavaoes}</td>
            <td>{val.integridade}</td>
            <td>{val.data_de_m}</td>
            <td>{val.idposto}</td>
            <td>{val.Tecnico}</td>
            
            <td>{val.nome}</td>
            <td>{val.lat}</td>
            <td>{val.lan}</td>
         
            </tr>
            
            }
            )}</tbody>}
    
            </table>
            <img  id="imagem"src={require('./images/printer.png')}  />
               
               <ReactToPrint
                       trigger={() => {
                          return <a  href="#">   
                          <button  id="opcao" value="Nao" onClick={Send} >Imprimir
                          </button>
              </a>;
                       }}
                       content={() => TabelaDemanu.current}
                     />
                      <button  id="opcao" value="Nao" onClick={(e)=>{
                        setLs(null);
                      }} >Fechar
                          </button>
                      <p>INICIO</p>
                          <input type='date' onChange={(e)=>{
                  setDado(e.target.value)
              }}/>
              <p>FIM</p>
              <input type='date' onChange={(e)=>{
                setDados(e.target.value)
            }}/>
             <h5>NOME DO POSTO</h5>
                     
            <input type="text" id="apesqui" name="name" autoComplete='off'  onChange={e=> setPost(e.target.value) } value={post}   required/>
            
      
      </div>}
    {selecionado ? (<InfoWindow position={{lat:parseFloat(selecionado.lat),lng:parseFloat(selecionado.lon)}} onCloseClick={()=>{setSelecionado(null);  }}>
      <div>
        <h4>{selecionado.descricao}</h4>
        
        <p>{selecionado.nome}</p>
        <p>Ultima manutencao</p>
      </div>
    </InfoWindow>
    ) : null}
  
    {Cliente && Cliente.map((line)=>(
      <Polyline
      path={path}
    />
    ))}
      {Cliente && Cliente.map((valor)=>(
        path.push({lat:parseFloat(valor.lat),lng:parseFloat(valor.lon)})
      ))}
      {path && <Polyline
      
      path={path}
      options={options}
    />}
      
    </GoogleMap>
    <ComponentToPrint ref={TabelaDemanu}> 
    <div className="relatorio">
            <div className='Sistema'>
            <div id="icon"><img  id="imagem"src={require('./images/gears copy.png')}  />
                        </div>
                <div id='texts'>
                    <h3>MOZAMBIQUE PREPAYMENT SYSTEM
               </h3>
               <h4>Tipo de relatorio:<h5>Historico de Manutencao</h5>
               </h4>
               <h5></h5>
               </div>
              
            </div>
            <table >
            <thead>
            <tr>
            <th>Consumo de gas</th>
            <th>pressao do gas</th>
            <th>Escavacoes</th>
            <th>Integridade</th>
            <th>data</th>
            <th>idPosto</th>
            <th>idTecnico</th>
            <th>Posto</th>
            <th>Lat</th>
            <th>Lon</th>
            </tr>
            </thead>
    
     
         {ls && <tbody>{SearchMeter(SearchD(ls)).map((val,key)=>
            {
            return  <tr> 
            <td>{val.consumo_gas}</td>
            <td>{val.pressao_gas}</td>
            <td>{val.escavaoes}</td>
            <td>{val.integridade}</td>
            <td>{val.data_de_m}</td>
            <td>{val.idposto}</td>
            <td>{val.Tecnico}</td>
            
            <td>{val.nome}</td>
            <td>{val.lat}</td>
            <td>{val.lan}</td>
         
            </tr>
            
            }
            )}</tbody>}
    
            </table>
    
            </div>
    </ComponentToPrint>

  </div>);
}

export default PipeLine;
